import React from 'react';
import styled from 'styled-components';
import useRating from '../hooks/use-rating';

export const TotalScore = styled.span`
  font-size: 2.125rem;
  font-weight: 700;
`;

export const MaximumScore = styled.span`
  font-size: 1.25rem;
`;

const TotalMaximumScore = ({
  companyId,
  siteId,
  ratingId,
  ratingIds,
  className,
}) => {
  const { score, maximumScore } = useRating({
    companyId,
    siteId,
    ratingId,
    ratingIds,
  });
  if (!score) {
    return null;
  }
  return (
    <div className={className}>
      <TotalScore>{score}</TotalScore>
      <MaximumScore>/{maximumScore}</MaximumScore>
    </div>
  );
};

export default styled(TotalMaximumScore)`
  margin-right: 0;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    margin-right: 1rem;
  }
`;
